import { Component, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from 'src/app/models/TableColumn';
import { TDeviceUsageDTO } from 'src/app/models/TDeviceUsageDTO.model';

import {
  BarController,
  BarElement,
  Chart,
  LinearScale, CategoryScale
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CustomerService } from 'src/app/services/customer.service';
import { PlanDeviceSummaryDTO } from 'src/app/models/PlanDeviceSummaryDTO.model';
import { SimpleRequestLongList } from 'src/app/shared/models/SimpleRequestLongList';
import { AddDeviceService } from 'src/app/services/add-device.service';
import * as saveAs from 'file-saver';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { Subject, takeUntil } from 'rxjs';

import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../../../shared/controls/table-control/table-control.component';
import { ConsumptionViewComponent } from '../../../plan-devices/consumption-view/consumption-view.component';
declare var bootstrap: any;

@Component({
    selector: 'app-customer-plan-devices',
    templateUrl: './customer-plan-devices.component.html',
    styleUrl: './customer-plan-devices.component.css',
    imports: [FormsModule, TableControlComponent, ConsumptionViewComponent]
})
export class CustomerPlanDevicesComponent {
  public usageData: TDeviceUsageDTO = null!;

  customerId?: number = undefined;
  userPlanId?: number = undefined;

  devices: PlanDeviceSummaryDTO[] = [];


  monthlyConsumption: number[] = [];
  monthlyHistoryConsumption: number[] = [];
  rangeMonts: string[] = [];

  fieldsCompletedFilter?: boolean = false;
  fromDate?: string = undefined;
  toDate?: string = undefined;

  devicesColumns: TableColumn[] = [
    { key: 'carrier', header: 'Carrier', },
    { key: 'iccid', header: 'ICCID', },
    { key: 'imei', header: 'IMEI', },
    { key: 'modemType', header: 'Modem Type', },
    { key: 'serialNumber', header: 'Serial Number', },
    { key: 'ip', header: 'IP', },
    { key: 'username', header: 'User Name', width: 200, },
    { key: 'username2', header: 'User Name 2', width: 200, },
    { key: 'custom1', header: 'Custom Field 1', width: 200, },
    { key: 'custom2', header: 'Custom Field 2', width: 200, },
    { key: 'firstName', header: 'First Name', width: 200, },
    { key: 'lastName', header: 'Last Name', width: 200, },
    {
      key: 'usageOnPeriod', header: 'Usage in MB',
      format: {
        type: 'number',
        decimalPlaces: 2,
        customFormatter: (value: any) => {
          return value ? `${Number(value).toLocaleString(
            undefined, { minimumFractionDigits: 2 }
          )} MB` : 'N/A';
        }
      }
    },
    { key: 'primary', header: 'Primary', },





    { key: 'activationDate', header: 'Activation Date', format: { type: 'date', dateFormat: 'MM-dd-yyyy' } },

    { key: 'deactivationDate', header: 'Deactivation Date', format: { type: 'date', dateFormat: 'MM-dd-yyyy', } },
    { key: 'suspensionDate', header: 'Suspension Date', format: { type: 'date', dateFormat: 'MM-dd-yyyy', } },

    { key: 'originatedFrom', header: 'Originated From', },
    { key: 'mdn', header: 'MDN', },
    { key: 'nameStatus', header: 'Status', },
  ];

  actionButtons = [
  
    { label: 'edit', class: 'primary', icon: 'bi bi-pencil' },


  ];



  /**
   *
   */
  constructor(private route: ActivatedRoute,
    private customerService: CustomerService,
    private addDeviceService: AddDeviceService,
    private router: Router,
  ) {



  }

  ngOnInit() {
    
    Chart.register(BarController, BarElement, CategoryScale, LinearScale, ChartDataLabels);

    this.route.params.subscribe((params) => {

      this.customerId = params['id'];
      this.userPlanId = params['userPlanId'];
    })

    this.customerService.getCustomerPlanByUserPlanId(this.userPlanId).subscribe({
      next: (data: PlanDeviceSummaryDTO[]) => {
        this.devices = data;
      },
      error: (error) => {
        //this.clearFields();
      }
    });

    this.customerService.getAllUsagesByUserPlanId(this.userPlanId).subscribe({
      next: (data: TDeviceUsageDTO) => {
        this.usageData = data;
      },
      error: (error) => {
        // Handle error if needed
      }
    });

  }

  onAction(event: { action: string; item: PlanDeviceSummaryDTO }): void {

    switch (event.action) {
   
      case 'edit':
        this.router.navigate(['/customers/view-customer/' + this.customerId + '/' + this.userPlanId + '/' + event.item.iccid], {
          relativeTo: this.route,
        });
        break;
   
    }
  }

  exportToExcelListPlanDevices() {
    let planDeviceIdList: number[] = [];
    planDeviceIdList = this.devices.map((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId as number);
    

    let simpleDataRequestLongList: SimpleRequestLongList = {} as SimpleRequestLongList;

    simpleDataRequestLongList.id = this.userPlanId;
    simpleDataRequestLongList.listIds = planDeviceIdList;

    this.addDeviceService.exportToExcelListPlanDevices(simpleDataRequestLongList).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownloadDevice(response);
        } else {
          this.handleGetFileErrorDevice();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  exportToExcelListPlanDevicesAnnual(confirmation: boolean) {

    if (confirmation) {
      let planDeviceIdList: number[] = [];

      planDeviceIdList = this.devices.map((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId as number);


      let simpleDataRequestLongList: SimpleRequestLongList = {} as SimpleRequestLongList;
      simpleDataRequestLongList.id = this.userPlanId;
      simpleDataRequestLongList.listIds = planDeviceIdList;
      simpleDataRequestLongList.fromDate = this.fromDate !== undefined ? new Date(this.fromDate) : undefined;
      simpleDataRequestLongList.toDate = this.toDate !== undefined ? new Date(this.toDate) : undefined;


      this.addDeviceService.exportToExcelListPlanDevicesAnnual(simpleDataRequestLongList).subscribe(
        (response: ResponseDataFile) => {
          if (response) {
            this.handleDownloadDevice(response);
          } else {
            this.handleGetFileErrorDevice();
          }
        },
        (error) => {
          console.error('Error al exportar el archivo Excel:', error);
        }
      );
    }
  }

  exportToExcelListPlanDevicesConsolidated() {
    
    let planDeviceIdList: number[] = [];
    
    planDeviceIdList = this.devices
      .map((device: PlanDeviceSummaryDTO) => device.aPlanDeviceId as number);
    

    let simpleDataRequestLongList = {} as SimpleRequestLongList;
    simpleDataRequestLongList.id = this.userPlanId;
    simpleDataRequestLongList.listIds = planDeviceIdList;

    this.addDeviceService.exportToExcelListPlanDevicesConsolidated(simpleDataRequestLongList).subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownloadDevice(response);
        } else {
          this.handleGetFileErrorDevice();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownloadDevice(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

  }

  private handleGetFileErrorDevice() {
    // this.alert = {
    //   alertMessage: 'Unexpected error. Please try again later.',
    //   alertType: 'alert alert-danger',
    //   alertCenter: false,
    //   alerTitle: '',
    //   duration: 3000
    // };
    // this.alertService.updateAlertState(
    //   this.alert
    // );
  }

  openConfirmationData() {

    //this.planselectedModal = plan;
    const secondModalElement = document.getElementById('confirmationData');
    if (secondModalElement) {
      const secondModal = new bootstrap.Modal(secondModalElement);
      secondModal.show();
    }
  }

  checkFieldsFilter() {
    if (this.fromDate && this.toDate) {
      if (new Date(this.fromDate) >= new Date(this.toDate)) {
        this.toDate = "";
        this.fieldsCompletedFilter = false;
      }
      else {
        this.fieldsCompletedFilter = true;
      }
    }
    else {
      this.fieldsCompletedFilter = false;
    }
  }

  minDate(): string | null {
    if (this.fromDate) {
      const minDate = new Date(this.fromDate);
      minDate.setDate(minDate.getDate() + 1);
      return minDate.toISOString().split('T')[0];
    }
    return null;
  }

  goBack(): void {
    window.history.back();
  }

}
